import SpinIcon from '@repo/ui/src/components/Icons/SpinIcon';
import { classNames } from '@repo/ui/src/utils/classNames';

interface Props {
  dark?: boolean;
  onClick?: () => void;
}

const SpinIndicator = ({ dark, onClick }: Props) => {
  return (
    <div 
      className={classNames(
        "tw-grid tw-grid-flow-col tw-gap-3",
        onClick && 'tw-group tw-cursor-pointer'
      )}
      onClick={onClick}
    >
      <div
        className={classNames(
          'tw-flex tw-items-center tw-mr-2 tw-w-5 md:tw-w-6',
          dark 
            ? 'tw-text-text-100 group-hover:tw-text-text-200 group-focus:tw-text-200'
            : 'tw-text-surface-500 group-hover:tw-text-surface-400'
        )}
      >
        <SpinIcon />
      </div>
      <p
        className={classNames(
          'tra-text-web-body-l tw-font-bold',
          dark 
            ? 'tw-text-text-100 group-hover:tw-text-text-200 group-focus:tw-text-200'
            : 'tw-text-surface-500 group-hover:tw-text-surface-400'
        )}
      >
        360° View
      </p>
    </div>
  );
};

export default SpinIndicator;
